import React from 'react';
import { Wrapper, BarChart, LineChart, DonutChart } from '../components';

class ChartsView extends React.Component{
    
    constructor(props) {
        super(props);
    
        this.state = {
            dataDonut2: {
                "labels": ["Hip", "Hop", "Hat"],
                "datasets": [
                {
                    "borderWidth": 0,
                    "data": [
                    10,
                    20,
                    60
                  ]
                }
              ]
            },
            dataDonut3: {
                "labels": ["Run", "Pass", "Catch"],
                "datasets": [
                {
                    "backgroundColor": ["red","pink","lime"],
                    "borderWidth": 0,
                    "data": [
                    10,
                    70,
                    5
                  ]
                }
              ]
            }
        };
    }
    
    render(){
        return (
            <Wrapper>
                <div className="row">
                    <div className="col-lg-7 col-xl-8 pt-1 pb-2">
                        <div className="row">
                            <div className="col-12 pb-4">
                                <div className="card card-body shadow-sm">
                                    <h3>Bar</h3>
                                    <BarChart />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="card card-body shadow-sm">
                                    <h3>Line</h3>
                                    <LineChart />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5 col-xl-4 pt-1 pb-2">
                        <div className="card card-body shadow-sm mb-4">
                            <h3>Donuts</h3>
                            <div className="row">
                                <div className="col-md-4 col-lg-12 pb-5">
                                    <DonutChart ref="donutChart1" className="mt-3 mx-auto" />
                                </div>
                                <div className="col-md-4 col-lg-12 pb-5">
                                    <DonutChart ref="donutChart2" data={this.state.dataDonut2} className="mt-3 mx-auto" />
                                </div>
                            </div>
                        </div>
                        <div className="card card-body shadow-sm">
                            <h3>Pie</h3>
                            <div className="row">
                                <div className="col-md-4 col-lg-12 pb-5">
                                    <DonutChart ref="donutChart3" data={this.state.dataDonut3} cutoutPercentage={0.1} className="mt-3 mx-auto" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        );
    }
}

export default ChartsView;
